


























































































import { mapActions, mapGetters } from 'vuex';

import { ELoyaltyFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';

import { ValidationRules } from '@/api/schema';
import {
  getStakingHappyHoursConfig,
  saveStakingHappyHoursConfig
} from '@/api/StakingPrograms';
import { enableOperatorFeatureFlag } from '@/api/FeatureFlags';

import Tooltip from '@/components/tooltip/Tooltip.vue';
import VFieldTimePicker from '@/components/VFieldTimePicker.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';

import { required, validNumber, positiveNumber } from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { DAYS_LIST } from '@/helpers/timeHelpers';

export default {
  name: 'HappyHoursSettings',
  components: {
    Tooltip,
    VFieldTimePicker,
    ConfirmationDialog
  },
  data: (): any => ({
    isHappyHoursFeatureFlagEnabledProcessing: false,
    dialogs: {
      isLoading: false,
      confirmationDialog: false,
      confirmationData: null
    },
    DAYS_LIST,
    formData: {
      workingDays: [],
      startTime: '',
      endTime: '',
      multiplier: ''
    },
    isFormProcessing: true,
    isFormValid: false
  }),
  computed: {
    ...mapGetters('FeatureFlags', [
      'isFeaturesLoading',
      'isEnabledFeatureFlag',
      'featureFlagIdByName'
    ]),
    ...mapGetters('Onboarding', ['operatorId']),
    formRules(): ValidationRules {
      return {
        workingDays: [(v) => (!!v && !!v.length) || `Field is required`],
        startTime: [],
        endTime: [],
        multiplier: [
          (v) => required(v, 'Field'),
          (v: string) => validNumber(v, 'Value is not valid'),
          positiveNumber,
          (v: string) => +v >= 1 || 'Multiplier must be greater than 1'
        ]
      };
    },
    isHappyHoursFeatureFlagEnabled(): boolean {
      return this.isEnabledFeatureFlag(ELoyaltyFeatureFlag.HAPPY_HOURS);
    },
    happyHoursFeatureFlagId(): number | null {
      return this.featureFlagIdByName(ELoyaltyFeatureFlag.HAPPY_HOURS);
    }
  },
  watch: {
    operatorId: {
      handler(): void {
        if (!this.operatorId) {
          return;
        }

        this.loadStakingHappyHoursConfig();
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('FeatureFlags', ['getOperatorLoyaltyFeatureFlags']),
    async loadStakingHappyHoursConfig(): Promise<void> {
      try {
        const { workingDays, endTime, startTime, multiplier } =
          await getStakingHappyHoursConfig();

        this.formData.workingDays = workingDays ?? [];
        this.formData.startTime = startTime ?? '';
        this.formData.endTime = endTime ?? '';
        this.formData.multiplier = multiplier ?? '';
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isFormProcessing = false;
      }
    },
    async handleOnFormSubmit(): Promise<void> {
      try {
        await this.$refs.form.validate();
        if (!this.isFormValid || this.isFormProcessing) {
          return;
        }

        this.isFormProcessing = true;

        await saveStakingHappyHoursConfig(this.formData);

        this.$toast.success(
          'Happy hours configuration successfully updated!'
        );
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isFormProcessing = false;
      }
    },
    async handleClickIsHappyHoursFeatureFlagEnabledSwitch(): Promise<void> {
      if (
        this.isHappyHoursFeatureFlagEnabledProcessing ||
        !this.happyHoursFeatureFlagId
      ) {
        return;
      }

      this.isHappyHoursFeatureFlagEnabledProcessing = true;

      if (this.isHappyHoursFeatureFlagEnabled) {
        this.openDeactivateHappyHoursFeatureFlagConfirmationDialog();
      } else {
        await this.changeHappyHoursFeatureFlagState();
      }
    },
    openDeactivateHappyHoursFeatureFlagConfirmationDialog(): void {
      this.dialogs.confirmationData = {
        disclaimer: `Are you sure you want to disable this feature?`,
        header: 'Confirm Feature Deactivation',
        okText: 'Deactivate',
        handler: () => this.changeHappyHoursFeatureFlagState()
      };
      this.dialogs.confirmationDialog = true;
    },
    async changeHappyHoursFeatureFlagState(): Promise<void> {
      try {
        this.dialogs.isLoading = true;
        this.isHappyHoursFeatureFlagEnabledProcessing = true;

        await enableOperatorFeatureFlag(
          this.happyHoursFeatureFlagId,
          !this.isHappyHoursFeatureFlagEnabled
        );

        this.handlerCloseConfirmationDialog();

        await this.getOperatorLoyaltyFeatureFlags();
      } catch (error) {
        errorToastMessage(error);
      } finally {
        this.isHappyHoursFeatureFlagEnabledProcessing = false;
        this.dialogs.isLoading = false;
      }
    },
    handlerCloseConfirmationDialog(): void {
      this.isHappyHoursFeatureFlagEnabledProcessing = false;

      this.dialogs.confirmationDialog = false;
      this.dialogs.confirmationData = null;
    }
  }
};
